import React, { useEffect, useState } from "react";

import { Chip, Paper, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(() => ({
	container: {
		padding: "4px 8px",
		borderRadius: 0,
		borderLeft: 0,
		borderRight: 0,
		borderTop: 0,
	},
	chip: {
		marginRight: 4,
		color: "#FFF",
		fontWeight: 500,
	},
}));

const TagsContainer = ({ ticket }) => {
	const classes = useStyles();
	const [tags, setTags] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/tags");
				setTags(data);
			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	useEffect(() => {
		if (ticket && Array.isArray(ticket.tags)) {
			setSelectedTags(ticket.tags);
		} else {
			setSelectedTags([]);
		}
	}, [ticket]);

	const handleChange = async (e, value) => {
		setSelectedTags(value);
		try {
			await api.put(`/ticket-tags/${ticket.id}`, {
				tagIds: value.map(tag => tag.id),
			});
		} catch (err) {
			toastError(err);
		}
	};

	if (!ticket || !ticket.id) return null;

	return (
		<Paper variant="outlined" className={classes.container}>
			<Autocomplete
				multiple
				size="small"
				options={tags}
				value={selectedTags}
				onChange={handleChange}
				getOptionLabel={option => option.name}
				getOptionSelected={(option, value) => option.id === value.id}
				renderTags={(value, getTagProps) =>
					value.map((option, index) => (
						<Chip
							size="small"
							className={classes.chip}
							style={{ backgroundColor: option.color || "#7C7C7C" }}
							label={option.name}
							{...getTagProps({ index })}
						/>
					))
				}
				renderInput={params => (
					<TextField
						{...params}
						variant="outlined"
						margin="dense"
						placeholder="Tags / Zona da reclamação"
					/>
				)}
			/>
		</Paper>
	);
};

export default TagsContainer;
